import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import {
  Form,
  FormGroup,
  Input,
  Col,
  Alert,
  Row,
  Container,
} from "reactstrap";
import * as Styled from "./Login.styles";
import { connect } from "react-redux";
import { loginUser } from "../../redux/actions/user/user.actions";
import { activateUserReset } from "../../redux/actions/user/activateUser.actions";
import validation from "./Login.validation";
import l10n from "../../localization";
import ResendActivation from "./_components/resendActivation";
import {
  LoginWrapper,
  FormWrapper,
  GlobalLink,
  GlobalButton,
  FloatingField,
  FloatingIcon,
  FloatingLabel,
} from "../../components/LoginComponents/LoginGlobal.styles";
import LogoColumn from "../../components/LoginComponents/LogoColumn";
import Loader from "../../components/Loader";
import { userLoggedIn, getUserInfo } from "../../redux/actions/user/user.actions";

function Login(props) {
  const INITIAL_USER_STATE = {
    email: "",
    password: "",
  };
  const [user, setUser] = useState(INITIAL_USER_STATE);
  const [validate, setValidation] = useState(INITIAL_USER_STATE);


  useEffect(() => {
    if (!props.user.userData.success && !props.user.userData.loading) { 
      const existingAuth = JSON.parse(localStorage.getItem("auth"));
      if (existingAuth) {
        props.userLoggedIn(existingAuth);
        props.getUserInfo();
      }
    }
    //eslint-disable-next-line
  }, []);



  const submitLogin = (e) => {
    e.preventDefault();
    const validateResponse = validation(user);
    if (!validateResponse) {
      props.loginUser(user);
      setValidation(INITIAL_USER_STATE);
      return;
    }

    setValidation(validateResponse);
  };


  if (props.user.userData.success) {
    if (props.location.state && props.location.state.from.pathname) {
      return (
        <Redirect
          to={
            props.location.state.from.pathname +
            props.location.state.from.search
          }
        />
      );
    }

    return <Redirect to="/" />;
  }

  if (props.user.userData.resendActivationMail) {
    props.activateUserReset();
    return <Redirect to={`/activation-sent/${user.email}`} />;
  }

  if (props.user.userData.loading) return null;

  return (
    <LoginWrapper>
      <Container>
        <Row noGutters={true}>
          <Col md="6" xs="12">
            <LogoColumn></LogoColumn>
          </Col>
          <Col md="6" xs="12">
            <FormWrapper>
              <Styled.ContentWrap>
                <Form onSubmit={submitLogin}>
                  <h2>{l10n.login.formTitle}</h2>
                  <FloatingField className={user.email ? "has-value" : ""}>
                    <FloatingIcon>
                      <i className="far fa-envelope"></i>
                    </FloatingIcon>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      value={user.email}
                      //invalid={!!validate.email}
                      onChange={(e) => {
                        setUser({ ...user, email: e.target.value });
                      }}
                    />
                    <FloatingLabel htmlFor="email" data-floating-label="true">
                      {l10n.login.email}
                    </FloatingLabel>
                  </FloatingField>

                  <FloatingField className={user.password ? "has-value" : ""}>
                    <FloatingIcon>
                      <i className="fas fa-lock"></i>
                    </FloatingIcon>
                    <Input
                      type="password"
                      name="password"
                      id="password"
                      value={user.password}
                      invalid={!!validate.password}
                      onChange={(e) => {
                        setUser({ ...user, password: e.target.value });
                      }}
                    />
                    <FloatingLabel
                      htmlFor="password"
                      data-floating-label="true"
                    >
                      {l10n.login.password}
                    </FloatingLabel>
                  </FloatingField>

                  {props.user.resendUserActivationMail.success && (
                    <FormGroup>
                      <Alert color="success">{l10n.login.resentSuccess}</Alert>
                    </FormGroup>
                  )}

                  {!props.user.resendUserActivationMail.success &&
                    props.user.userData.error && (
                      <FormGroup>
                        <Alert
                          color="danger"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {l10n.general.somethingWentWrong}:
                          <ul>
                            {(props.user.userData.error || []).map(
                              (err, index) => (
                                <li key={index}>
                                  {l10n.serverErrors[err]}
                                  {err === "user_not_yet_activated" &&
                                    (props.user.resendUserActivationMail
                                      .loading ? (
                                      <Loader inline={true} />
                                    ) : (
                                      <ResendActivation email={user.email} />
                                    ))}
                                </li>
                              )
                            )}
                          </ul>
                        </Alert>
                      </FormGroup>
                    )}

                  <FormGroup>
                    <Row noGutters={true}>
                      <Col className="d-flex mb-lg-0 mb-md-4 mb-3">
                        <GlobalLink to="/password-recovery">
                          {l10n.login.forgottenPassword}
                        </GlobalLink>
                      </Col>
                      <Col lg="5" className="text-lg-right">
                        <GlobalButton color="primary">
                          {l10n.login.signIn}
                        </GlobalButton>
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup>
                    {l10n.login.dontHaveAccount}{" "}
                    <GlobalLink to="/register">
                      {l10n.login.signUpHere}
                    </GlobalLink>
                  </FormGroup>
                </Form>
              </Styled.ContentWrap>
            </FormWrapper>
          </Col>
        </Row>
      </Container>
    </LoginWrapper>
  );
}

export default connect(({ user }) => ({ user }), {
  loginUser,
  activateUserReset,
  userLoggedIn, 
  getUserInfo
})(Login);
